import { Directive, ElementRef, HostListener, Input } from '@angular/core';

// CycleTabBoundaryDirective
// Intercepts Tab at the logical first and last editable field across all rows/columns
// to implement wrap-around keyboard navigation without disturbing native behavior elsewhere.
@Directive({
  selector: '[cycleTabBoundary]',
})
export class CycleTabBoundaryDirective {
  // Mark this host as the first logical field
  @Input() cycleIsFirst = false;
  // Mark this host as the last logical field
  @Input() cycleIsLast = false;
  // CSS selector for the first host element in the cycle
  @Input() cycleFirstSelector = '';
  // CSS selector for the last host element in the cycle
  @Input() cycleLastSelector = '';

  constructor(private el: ElementRef<HTMLElement>) {}

  @HostListener('keydown', ['$event'])
  onKeydown(ev: KeyboardEvent) {
    if (ev.key !== 'Tab') return;

    // Shift+Tab on first -> wrap to last
    if (ev.shiftKey && this.cycleIsFirst && this.cycleLastSelector) {
      ev.preventDefault();
      this.focusTarget(this.cycleLastSelector);
      return;
    }

    // Tab on last -> wrap to first
    if (!ev.shiftKey && this.cycleIsLast && this.cycleFirstSelector) {
      ev.preventDefault();
      this.focusTarget(this.cycleFirstSelector);
    }
  }

  private focusTarget(selector: string) {
    const host = document.querySelector(selector) as HTMLElement | null;
    if (!host) return;
    // Attempt to focus internal input inside shadow root commonly used by goab-input-number
    const inner = (
      host.children?.[0] as HTMLElement | undefined
    )?.shadowRoot?.querySelector('input');
    if (inner instanceof HTMLInputElement) {
      inner.focus({ preventScroll: true });
      inner.select();
      return;
    }
    // Fallback to host if internal input not found
    host.focus({ preventScroll: true });
  }
}
